import Vue from 'vue';
import { belongConfig, orderConfig, gatherConfig } from '@/common/utils/function-config';
import self from '@/common/utils/global-config';
import Swagger from '@/common/utils/swagger';
import * as Constants from '@/common/utils/constants';
import * as Tools from '@/common/utils/tools';
import * as Messages from '@/common/utils/messages';
import * as ServiceConfig from '@/common/utils/service-config';

// 项目初始化时，调用医院各种信息
export function initialHospitalInformation() {
  return new Promise(resolve => {
    let p1 = Promise.resolve('');
    let p2 = Promise.resolve('');
    let p3 = Promise.resolve('');
    let p4 = Promise.resolve('');
    p1 = obtainHopsitalInformation();
    p2 = obtainHospitalAreaInformation();
    p3 = obtainHospitalFunctionInformation();
    p4 = obtainHospitalConfigInformation();
    Promise.all([p1, p2, p3, p4]).then(() => {
      window.eventBus.$emit('Broadcast_InitialComplete');
      resolve(true);
    });
  });
}

// 登录成功后需调用各种信息
export function suffixLogin() {
  return new Promise(resolve => {
    // 山东省立医院-进修报名无需调用就诊人等
    if (self.$sn.utils.getProjectPattern() === Constants.PROJECT_PATTERN_JXBM) {
      resolve(true);
    }
    else {
      let p1 = Promise.resolve('');
      if (self.$sn.utils.isOpenFunction(Constants.FUNCTION_ID_PLYTY)) {
        p1 = obtainUserPhysicalLeader();
      }
      Promise.all([p1]).then(() => {
        resolve(true);
      });
    }
  });
}

// 处理当前医院是否可用
export function verifyHospitalInformation() {
  const FuncTree = () => {
    let tree = belongConfig(); // 通用功能树型结构
    const special = belongConfig(self.$sn.utils.getHospitalId()); // 医院特质化功能树型结构
    const order = orderConfig(); // 订单功能路由表
    const gather = gatherConfig(); // 功能路由表
    if (!self.$sn.validate.empty(special)) {
      tree = self.$sn.format.merge(tree, special);
    }
    Object.keys(tree).forEach(key => {
      Vue.set(tree[key], 'func', []);
      if (tree[key].compare) {
        Object.keys(tree[key].compare).forEach(id => {
          if (self.$sn.utils.isShowFunction(id)) {
            let final = {
              ...tree[key].compare[id],
              id: id
            };
            const piece = id.split(',').length > 1;
            if (id.indexOf('other') === -1) {
              let match = {};
              if (final.mode === 'record') {
                match = order.find(result => result.id === (piece ? id.split(',')[0] : id));
              }
              else {
                match = gather.find(result => result.id === (piece ? id.split(',')[0] : id));
              }
              if (!self.$sn.validate.empty(match)) {
                if (piece && final.alias) delete match.alias;
                final = {
                  ...final,
                  ...match
                };
              }
              if (self.$sn.validate.empty(final.alias)) {
                const alias = self.$sn.utils.getFunctionTitle('0', (piece ? id.split(',')[0] : id));
                if (!self.$sn.validate.empty(alias)) {
                  Vue.set(final, 'alias', alias);
                }
              }
            }
            tree[key].func.push(final);
          }
        });
        tree[key].func = self.$sn.format.digitalSort(tree[key].func);
      }
    });
    self.$sn.utils.setHospitalSessionStorage('HospitalFunctionTreeInformation', tree);
    window.eventBus.$emit('Broadcast_HospitalFunctionTreeInformation');
  };
  let verify = false;
  if (self.$sn.utils.getHospitalLocalStorage('HospitalInformation') &&
  self.$sn.utils.getHospitalLocalStorage('HospitalAreaInformation') &&
  self.$sn.utils.getHospitalLocalStorage('HospitalInformation').enabled &&
  self.$sn.utils.getHospitalSessionStorage('HospitalFunctionInformation') &&
  self.$sn.utils.getHospitalSessionStorage('HospitalConfigInformation')) {
    FuncTree();
    verify = true;
  }
  return verify;
}

// 调用医院信息
export function obtainHopsitalInformation() {
  return new Promise(resolve => {
    const params = {
      url: self.$sn.format.caption(Swagger.getHospitalInformation, [self.$sn.utils.getHospitalId()])
    };
    self.$sn.utils.ordinaryRequest(params).then(result => {
      if (result && result.code === 0 && result.data && result.data.hosId) {
        self.$sn.utils.setHospitalLocalStorage('HospitalInformation', result.data);
        resolve(result.data);
        return false;
      }
      resolve({});
    });
  });
}

// 调用医院院区信息
export function obtainHospitalAreaInformation() {
  return new Promise(resolve => {
    const params = {
      url: Swagger.getHospitalAreaInformation,
      query: {
        hosId: self.$sn.utils.getHospitalId()
      }
    };
    self.$sn.utils.ordinaryRequest(params).then(result => {
      if (result && result.code === 0 && result.data && result.data.length > 0) {
        self.$sn.utils.setHospitalLocalStorage('HospitalAreaInformation', result.data);
        resolve(result.data);
        return false;
      }
      resolve([]);
    });
  });
}

// 调用医院功能权限信息
export function obtainHospitalFunctionInformation() {
  return new Promise(resolve => {
    const params = {
      url: Swagger.getHospitalFunctionInformation,
      query: {
        hosId: self.$sn.utils.getHospitalId(),
        projectType: self.$sn.utils.getProjectType(),
        platformType: self.$sn.utils.getPlatformType()
      }
    };
    self.$sn.utils.ordinaryRequest(params).then(result => {
      if (result && result.code === 0 && result.data && result.data.length > 0) {
        self.$sn.utils.setHospitalSessionStorage('HospitalFunctionInformation', result.data);
        resolve(result.data);
        return false;
      }
      resolve([]);
    });
  });
}

// 调用医院各功能配置信息
export function obtainHospitalConfigInformation() {
  return new Promise(resolve => {
    Tools.getHospitalConfigInformation([
      Constants.CONFIG_TYPE_GLOBAL,
      Constants.CONFIG_TYPE_HOMEPAGE,
      Constants.CONFIG_TYPE_LOGIN,
      Constants.CONFIG_TYPE_PATIENT
    ]).then(result => {
      resolve(result);
    });
  });
}

// 调用当前账号就诊人列表信息
export function obtainPatientInfoByCondition(refresh) {
  return new Promise(resolve => {
    if (!refresh) {
      if (!self.$sn.validate.empty(self.$sn.utils.getHospitalLocalStorage('Login_PatientList'))) {
        resolve({
          code: 0,
          data: self.$sn.utils.getHospitalLocalStorage('Login_PatientList'),
          msg: ''
        });
        return false;
      }
    }
    const params = {
      url: Swagger.getPatientInfoByCondition,
      query: {
        hosId: self.$sn.utils.getHospitalId(),
        bindType: self.$sn.utils.getPlatformType(),
        openId: self.$sn.utils.getOpenId()
      },
      header: true
    };
    self.$sn.utils.ordinaryRequest(params, ServiceConfig.getPatientInfoByConditionComplete).then(result => {
      const res = {
        code: 0,
        data: [],
        msg: ''
      };
      if (result) {
        if (result.code === 0) {
          if (result.data && result.data.length > 0) res.data = result.data;
        }
        else {
          res.code = result.code;
          res.msg = result.msg;
        }
      }
      else {
        res.code = 1;
        res.msg = Messages.C001;
      }
      resolve(res);
    }).catch(() => {
      resolve({
        code: 2,
        msg: Messages.C001
      });
    });
  });
}

// 调用当前账号是否为团体体检负责人
export function obtainUserPhysicalLeader() {
  return new Promise(resolve => {
    const params = {
      url: self.$sn.format.caption(Swagger.getUserPhysicalLeader, [self.$sn.utils.getHospitalId()]),
      query: {
        platformId: self.$sn.utils.getPlatformType(),
        platformUserId: self.$sn.utils.getOpenId(),
        phone: self.$sn.utils.getLoginPhone()
      },
      header: true
    };
    self.$sn.utils.ordinaryRequest(params).then(result => {
      if (result && result.code === 0 && result.data) {
        const user = self.$sn.vuex.get('vuex_login_user.' + self.$sn.utils.getHospitalId());
        Vue.set(user, 'leader', '1');
        self.$sn.vuex.set('vuex_login_user.' + self.$sn.utils.getHospitalId(), user);
      }
      resolve();
    });
  });
}
